<div ngbAccordion #accordion="ngbAccordion" class="collapsible-mobile-card">
	<div [ngbAccordionItem]="header()" [collapsed]="false" [destroyOnHide]="true">
		<div ngbAccordionHeader>
			<button ngbAccordionButton class="btn btn-flat">{{header()}}
			</button>
		</div>
		<div ngbAccordionCollapse>
			<div ngbAccordionBody class="d-flex flex-column gap-2">
				<ng-template>
					<ng-content></ng-content>
					@if(buttonText()){
					<common-button-row [center]="true">
						<button class="btn btn-primary btn-large" (click)="accordion.collapse(header())">{{
							buttonText()}}</button>
					</common-button-row>
					}
				</ng-template>
			</div>
		</div>
	</div>
</div>